import { createFileRoute } from '@tanstack/react-router';

import { StationDevicesPage } from '../modules/station-devices/ui/pages/StationDevicesPage';

export const Route = createFileRoute(
  '/_authenticated/dashboard/locations/$locationId/station-devices/',
)({
  component: StationDevicesPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Station devices'],
  },
});
